import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";

import DataTable from "../../../lib/components/DataTable";
import EmptyState from "../../../lib/components/EmptyState";
import customPlanService from "../../../service/customPlanService";

const BillingDataTable = ({ data = [], isLoading, onEdit, onToggleStatus, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  if (isLoading) return null;

  const handleOpenMenu = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setActiveRow(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveRow(null);
  };

  const handleStatusUpdate = async () => {
    if (!activeRow) return;

    try {
      await customPlanService.updateStatus(activeRow.id, !activeRow.isActive);
      onToggleStatus?.();
    } catch (error) {
      console.error("Failed to update plan status:", error);
    } finally {
      handleCloseMenu();
    }
  };

  const columns = [
    {
      key: "name",
      header: "Plan Name",
      render: (_, row) => (
        <>
          <div>{row.name}</div>
          {row.description && (
            <div
              style={{
                fontSize: "11px",
                color: "#6B7280",
                marginTop: "2px",
              }}
            >
              {row.description.length > 20 ? `${row.description.slice(0, 20)}...` : row.description}
            </div>
          )}
        </>
      ),
    },
    {
      key: "price",
      header: "Price / Period",
    },
    {
      key: "status",
      header: "Status",
      render: (_, row) => (
        <span
          className={`badge px-3 py-1 ${row.isActive ? "bg-primary-subtle text-primary" : "bg-secondary-subtle text-secondary"}`}
          style={{ borderRadius: 20 }}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      key: "actions",
      header: "Actions",
      render: (_, row) => (
        <Button color="secondary" onClick={(e) => handleOpenMenu(e, row)} sx={{ minWidth: "auto", px: 0.5 }}>
          ⋮
        </Button>
      ),
    },
  ];

  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      {/* MUI Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            onEdit?.(activeRow);
            handleCloseMenu();
          }}
        >
          Edit
        </MenuItem>

        <MenuItem onClick={handleStatusUpdate}>{activeRow?.isActive ? "Make Inactive" : "Make Active"}</MenuItem>
      </Menu>

      <EmptyState isEmpty={!isLoading && !data.length} />
    </>
  );
};

export default BillingDataTable;
